import { render, staticRenderFns } from "./AngularGaugeWidget.vue?vue&type=template&id=5925bc0f"
import script from "./AngularGaugeWidget.vue?vue&type=script&lang=js"
export * from "./AngularGaugeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports